<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="dashboard-analytics">
        <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5 mb-base">
                <div class="p-4 employee h-full">
                    <div class="vx-col">
                        <feather-icon class="p-3 rounded-full" icon="UsersIcon"
                                      svgClasses="h-12 w-12" style="color: #0095ff;"/>
                        <div class="float-right">
                            <div>
                                <h2 class="font-bold float-right totalEmployee">{{ totalEmployee }}</h2>
                            </div>
                            <label class="float-right textlabel">NHÂN VIÊN</label>
                        </div>
                    </div>
                </div>
                <div class="detailEmployee cursor p-1" @click="showTotalEmployee">
                    <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-5 w-5" style="color: #fff"/>
                    <span class="cursor-pointer ml-2" style="color:#fff">Xem chi tiết</span>
                </div>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5 mb-base">
                <div class="p-4 checkinok h-full">
                    <div class="vx-col">
                        <feather-icon class="p-3 rounded-full" icon="CheckCircleIcon"
                                      svgClasses="h-12 w-12" style="color: #00d6ac;"/>
                        <div class="float-right">
                            <div>
                                <h2 class="font-bold float-right totalCheckin">{{ totalCheckin }}</h2>
                            </div>
                            <label class="float-right textlabel">ĐÃ CHẤM CÔNG</label>
                        </div>
                    </div>
                </div>
                <div class="detailCheckinOk cursor p-1" @click="showIsCheckin">
                    <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-5 w-5" style="color: #fff"/>
                    <span class="cursor-pointer ml-2" style="color:#fff">Xem chi tiết</span>
                </div>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5 mb-base">
                <div class="p-4 showIsLate h-full">
                    <div class="vx-col">
                        <feather-icon class="p-3 rounded-full" icon="ClockIcon"
                                      svgClasses="h-12 w-12" style="color: #dab200;"/>
                        <div class="float-right">
                            <div>
                                <h2 class="font-bold float-right totalLate">{{ totalLate }}</h2>
                            </div>
                            <label class="float-right textlabel">ĐI MUỘN</label>
                        </div>
                    </div>
                </div>
                <div class="detailLate cursor p-1" @click="showIsLate">
                    <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-5 w-5" style="color: #fff"/>
                    <span class="cursor-pointer ml-2" style="color:#fff">Xem chi tiết</span>
                </div>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5 mb-base">
                <div class="p-4 showIsLocation h-full">
                    <div class="vx-col">
                        <feather-icon class="p-3 rounded-full" icon="RssIcon"
                                      svgClasses="h-12 w-12" style="color: #00b752;"/>
                        <div class="float-right">
                            <div>
                                <h2 class="font-bold float-right totalNotCheckin">{{ totalCheckinLocation || 0 }}</h2>
                            </div>
                            <label class="float-right textlabel">LÀM VIỆC TỪ XA</label>
                        </div>
                    </div>
                </div>
                <div class="detailLocation cursor p-1" @click="showIsCheckinLocation()">
                    <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-5 w-5" style="color: #fff"/>
                    <span class="cursor-pointer ml-2" style="color:#fff">Xem chi tiết</span>
                </div>
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5 mb-base">
                <div class="p-4 showIsCheckin h-full">
                    <div class="vx-col">
                        <feather-icon class="p-3 rounded-full" icon="XSquareIcon"
                                      svgClasses="h-12 w-12" style="color: #ff2537"/>
                        <div class="float-right">
                            <div>
                                <h2 class="font-bold float-right totalNotCheckin">{{ totalNotCheckin }}</h2>
                            </div>
                            <label class="float-right textlabel">CHƯA CHẤM CÔNG</label>
                        </div>
                    </div>
                </div>
                <div class="detailNotChecin cursor p-1" @click="showIsNotCheckin()">
                    <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-5 w-5" style="color: #fff"/>
                    <span class="cursor-pointer ml-2" style="color:#fff">Xem chi tiết</span>
                </div>
            </div>
        </div>
        <div class="vx-row mt-3">
            <div class="vx-col md:w-1/3 w-full checkinweek mb-base">
                <div class="card-lave">
                    <div class="card">
                        <h4>CHẤM CÔNG SỚM</h4>
                        <span style="font-size: 14px; color: #888;">Trong 7 ngày qua</span>
                        <h6 class="mt-4" style="font-size: 12px; color:#888">Số lượng nhân viên</h6>
                        <vue-apex-charts v-if="isShowLineChartCheckin" type="area" height="210"
                                         :options="earlyCheckIn.chartOptions"
                                         :series="earlyCheckIn.series"></vue-apex-charts>
                    </div>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full checkinweek mb-base">
                <div class="card-lave">
                    <div class="card">
                        <h4>CHẤM CÔNG MUỘN</h4>
                        <span style="font-size: 14px; color: #888;">Trong 7 ngày qua</span>
                        <h6 class="mt-4" style="font-size: 12px; color:#888">Số lượng nhân viên</h6>
                        <vue-apex-charts v-if="isShowLineChartCheckin" type="area" height="210"
                                         :options="lateCheckIn.chartOptions"
                                         :series="lateCheckIn.series"></vue-apex-charts>
                    </div>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full  checkinweek mb-base">
                <div class="card-lave">
                    <div class="card">
                        <h4>KHÔNG CHẤM CÔNG</h4>
                        <span style="font-size: 14px; color: #888;">Trong 7 ngày qua</span>
                        <h6 class="mt-4" style="font-size: 12px; color:#888">Số lượng nhân viên</h6>
                        <vue-apex-charts v-if="isShowLineChartCheckin" type="area" height="210"
                                         :options="notCheckIn.chartOptions"
                                         :series="notCheckIn.series"></vue-apex-charts>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full sm:w-1/3 w-full mb-base">
                <div class="card-lave">
                    <div class="card">
                        <h4>TOP 5 CHẤM CÔNG SỚM</h4>
                        <div class="vx-card__title">Nhân viên đi làm sớm
                            nhất <span class="hightlight_subtitle_soon">hôm nay</span></div>
                        <div class="checkinlate">
                            <div class="text-center" v-if="!isShowEmployeeEarly">
                                <div>
                                    <feather-icon class="p-3 rounded-full opacity02" icon="ArchiveIcon"
                                                  svgClasses="h-16 w-16"/>
                                </div>
                                <label>Không có dữ liệu</label>
                            </div>
                            <div slot="no-body" v-if="isShowEmployeeEarly">
                                <VuePerfectScrollbar ref="scrollDialog"
                                                     class="scroll-area--nofications-dropdown scroll p-0 mb-2"
                                                     :settings="settings">
                                    <div :key="index" class="isEmployeeLeave w-full cursor"
                                         v-for="(soon, index) in employeeEarly"
                                         @click="goEmployeeTimeKeeping(soon.employeeId, true)">
                                        <div class="flex items-center">
                                            <div class="zoom">
                                                <vs-avatar class="flex-grow" size="70px" :src="soon.urlImage"/>

                                            </div>
                                            <div class="vx-col ml-4 w-full">
                                                <div class="flex">
                                                    <div class="md:w-7/12 w-full">
                                                        <span class="font-bold" style="color:black">{{
                                                                soon.fullName
                                                            }}</span>
                                                    </div>
                                                    <div class="md:w-5/12 w-full text-right mr-4">
                                                        <span class="font-bold" style="font-size:12px; color:#444">{{
                                                                soon.checkinTime
                                                            }}</span>
                                                    </div>
                                                </div>
                                                <span class="vx-row ml-0" style="font-size:12px; color:#444">
                                                    {{
                                                        soon.organizationBranchName ? soon.organizationBranchName : 'Intlabs'
                                                    }}</span>
                                                <span class="vx-row ml-0" style="font-size:12px; color:#444">
                                                    {{ soon.departmentName }}</span>
                                            </div>

                                        </div>
                                    </div>
                                </VuePerfectScrollbar>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div class="vx-col w-full sm:w-1/3 mb-base">
                <div class="card-lave">
                    <div class="card">
                        <h4>TOP 5 CHẤM CÔNG MUỘN</h4>
                        <div class="vx-card__title">Nhân viên đi làm muộn
                            nhất <span class="hightlight_subtitle_late">hôm qua</span></div>
                        <div class="checkinlate">
                            <div class="text-center" v-if="!isShowEmployeeLate">
                                <div>
                                    <feather-icon class="p-3 rounded-full opacity02" icon="ArchiveIcon"
                                                  svgClasses="h-16 w-16"/>
                                </div>
                                <label>Không có dữ liệu</label>
                            </div>
                            <div slot="no-body" v-if="isShowEmployeeLate">
                                <VuePerfectScrollbar ref="scrollDialog"
                                                     class="scroll-area--nofications-dropdown scroll p-0 mb-2"
                                                     :settings="settings">
                                    <div :key="index" class="isEmployeeLeave w-full cursor"
                                         v-for="(late, index) in employeeLate"
                                         @click="goEmployeeTimeKeeping(late.employeeId, false)">
                                        <div class="flex items-center">
                                            <div class="zoom">
                                                <vs-avatar class="flex-grow" size="70px" :src="late.urlImage"/>

                                            </div>
                                            <div class="vx-col ml-4 w-full">
                                                <div class="flex">
                                                    <div class="md:w-7/12 w-full">
                                                        <span class="font-bold" style="color:black">{{
                                                                late.fullName
                                                            }}</span>
                                                    </div>
                                                    <div class="md:w-5/12 w-full text-right mr-4">
                                                        <span class="font-bold" style="font-size:12px; color:#444">{{
                                                                late.checkinTime
                                                            }}</span>
                                                    </div>
                                                </div>
                                                <span class="vx-row ml-0" style="font-size:12px; color:#444">
                                                    {{
                                                        late.organizationBranchName ? late.organizationBranchName : 'Intlabs'
                                                    }}</span>
                                                <span class="vx-row ml-0" style="font-size:12px; color:#444">
                                                    {{ late.departmentName }}</span>
                                            </div>

                                        </div>
                                    </div>
                                </VuePerfectScrollbar>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="vx-col w-full sm:w-1/3 mb-base">
                <div class="card-lave">
                    <div class="card">
                        <h4>ĐƠN XIN NGHỈ</h4>
                        <label class="vx-card__title">Nhân viên có đơn xin nghỉ</label>
                        <div>
                            <div class="text-center" v-if="!isShowEmployeeLeave">
                                <div>
                                    <feather-icon class="p-3  opacity02" icon="ArchiveIcon" svgClasses="h-16 w-16"/>
                                </div>
                                <label>Không có dữ liệu</label>
                            </div>
                            <div slot="no-body" v-if="isShowEmployeeLeave">
                                <VuePerfectScrollbar ref="scrollDialog"
                                                     class="scroll-area--nofications-dropdown scroll p-0 mb-2"
                                                     :settings="settings">
                                    <div :key="index" class="isEmployeeLeave w-full cursor"
                                         v-for="(leave, index) in leaveData"
                                         @click="goLeave(leave.organizationBranchId, leave.id)">
                                        <div class="flex items-center">
                                            <div class="zoom">
                                                <vs-avatar class="flex-grow" size="70px"
                                                           :src="leave.fileManagers[0].url"/>

                                            </div>
                                            <div class="vx-col ml-4 w-full">
                                                <div class="flex">
                                                    <div class="md:w-7/12 w-full">
                                                        <span class="font-bold"
                                                              style="color:black">{{ leave.employeeFullName }}</span>
                                                    </div>
                                                    <div class="md:w-5/12 w-full text-right mr-4">
                                                        <span class="font-bold"
                                                              style="font-size:12px; color:#444">{{
                                                                leave.displayStatus
                                                            }}</span>
                                                    </div>
                                                </div>
                                                <span style="font-size:12px; color:#444">{{
                                                        leave.displayLeaveDate
                                                    }}</span>
                                                <span class="vx-row ml-0" style="font-size:12px; color:#444">
                                                    {{ leave.organizationBranchName }}</span>
                                                <span class="vx-row ml-0" style="font-size:12px; color:#444">
                                                    {{ leave.departmentName }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </VuePerfectScrollbar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <div class="vx-card card-department">
                    <div class="card">
                        <h4>PHÒNG HỌP</h4>
                        <span style="font-size: 14px; color: #888;">Lịch đặt phòng hôm nay</span>
                        <CalendarsCustome :selectedView="selectedViewDay" :scheduleList="scheduleListDay"/>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
//Calender
import CalendarsCustome from "../components/CalendarsCustome.vue"
import VxTimeline from "../components/timeline/VxTimeline";
//EndCalender

import authConfig from '../../auth_config.json';

export default {
    data() {
        return {
            //calender - Phòng họp
            selectedViewDay: 'day',
            scheduleListDay: [],
            //endCalendars - Phòng họp
            //Calendars - Sự kiện
            selectedViewMonth: 'month',
            scheduleListMonth: [],
            //endCalendars - Sự kiện
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .30,
                suppressScrollX: true,
            },
            totalCheckinLocation: 0,
            isShowBookMeeting: false,
            isShowEmployeeLeave: false,
            isShowLineChartCheckin: false,
            lineChartCheckin: {
                series: [],
                chartOptions: {
                    chart: {
                        redrawOnParentResize: true,
                        toolbar: {show: false},
                        dropShadow: {
                            enabled: true,
                            opacity: 0.10,
                        },
                        animations: {
                            enabled: false,
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        //dashArray: [0, 8],
                        width: [2, 2, 2, 2, 2, 2, 2, 2, 2,
                            2, 2, 2, 2, 2, 2, 2, 2
                            , 2, 2, 2, 2, 2, 2, 2, 2],
                    },
                    grid: {
                        borderColor: '#e7e7e7',
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    legend: {
                        position: 'top',
                        show: true,
                    },
                    colors: ['#ff0000', '#3BD12F', '#6a06ee'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            inverseColors: false,
                            gradientToColors: ['#ff0000', '#12f300', '#6a06ee'],
                            shadeIntensity: 1,
                            type: 'horizontal',
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100, 100, 100]
                        },
                    },
                    markers: {
                        size: 0,
                        hover: {
                            size: 5
                        }
                    },
                    xaxis: {
                        categories: [],
                    },
                }
            },
            notCheckIn: {
                series: [],
                chartOptions: {
                    chart: {
                        redrawOnParentResize: true,
                        toolbar: {show: false},
                        dropShadow: {
                            enabled: true,
                            opacity: 0.10,
                        },
                        animations: {
                            enabled: false,
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: [2, 2, 2, 2, 2, 2, 2, 2, 2,
                            2, 2, 2, 2, 2, 2, 2, 2
                            , 2, 2, 2, 2, 2, 2, 2, 2],
                    },
                    grid: {
                        borderColor: '#e7e7e7',
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    legend: {
                        position: 'top',
                        show: true,
                    },
                    colors: ['#ff0000'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            inverseColors: false,
                            gradientToColors: ['#ff0000'],
                            shadeIntensity: 1,
                            type: 'horizontal',
                            opacityFrom: 0.3,
                            opacityTo: 0.3,
                            stops: [0, 100, 100, 100]
                        },
                    },
                    markers: {
                        size: 0,
                        hover: {
                            size: 5
                        }
                    },
                    xaxis: {
                        categories: [],
                    },
                }
            },
            earlyCheckIn: {
                series: [],
                chartOptions: {
                    chart: {
                        redrawOnParentResize: true,
                        toolbar: {show: false},
                        dropShadow: {
                            enabled: true,
                            opacity: 0.10,
                        },
                        animations: {
                            enabled: false,
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: [2, 2, 2, 2, 2, 2, 2, 2, 2,
                            2, 2, 2, 2, 2, 2, 2, 2
                            , 2, 2, 2, 2, 2, 2, 2, 2],
                    },
                    grid: {
                        borderColor: '#e7e7e7',
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    legend: {
                        position: 'top',
                        show: true,
                    },
                    colors: ['#3BD12F'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            inverseColors: false,
                            gradientToColors: ['#12f300'],
                            shadeIntensity: 1,
                            type: 'horizontal',
                            opacityFrom: 0.3,
                            opacityTo: 0.3,
                            stops: [0, 100, 100, 100]
                        },
                    },
                    markers: {
                        size: 0,
                        hover: {
                            size: 5
                        }
                    },
                    xaxis: {
                        categories: [],
                    },
                }
            },
            lateCheckIn: {
                series: [],
                chartOptions: {
                    chart: {
                        redrawOnParentResize: true,
                        toolbar: {show: false},
                        dropShadow: {
                            enabled: true,
                            opacity: 0.10,
                        },
                        animations: {
                            enabled: false,
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: [2, 2, 2, 2, 2, 2, 2, 2, 2,
                            2, 2, 2, 2, 2, 2, 2, 2
                            , 2, 2, 2, 2, 2, 2, 2, 2],
                    },
                    grid: {
                        borderColor: '#e7e7e7',
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    legend: {
                        position: 'top',
                        show: true,
                    },
                    colors: ['#FCB71E'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            inverseColors: false,
                            gradientToColors: ['#FCB71E'],
                            shadeIntensity: 1,
                            type: 'horizontal',
                            opacityFrom: 0.3,
                            opacityTo: 0.3,
                            stops: [0, 100, 100, 100]
                        },
                    },
                    markers: {
                        size: 0,
                        hover: {
                            size: 5
                        }
                    },
                    xaxis: {
                        categories: [],
                    },
                }
            },
            isShowEmployeeEarly: false,
            isShowEmployeeLate: false,
            totalEmployee: 0,
            totalCheckin: 0,
            totalLate: 0,
            totalNotCheckin: 0,
            leaveData: [],
            employeeEarly: [],
            employeeLate: [],
            roomMeeting: [],
            employees: [],
            bookroomMeetings: [],
            organizationBranchOptions: [],
        }
    },
    components: {
        VxTimeline,
        CalendarsCustome,
        VueApexCharts,
        VuePerfectScrollbar,
    },
    methods: {
        showIsCheckinLocation() {

        },
        showIsNotCheckin() {
            this.$router.push('/user/time-keeping?isCheckin=false');
        },
        showIsLate() {
            this.$router.push('user/time-keeping?isLate=true');
        },
        showIsCheckin() {
            this.$router.push('/user/time-keeping?isCheckin=true')
        },
        showTotalEmployee() {
            this.$router.push('/user/manage-employee');
        },
        goEmployeeTimeKeeping(id, status) {
            let check = null;
            if (!status) check = true;
            this.$router.push(`/user/time-keeping?theBestLate=${!status}&isLate=${check}&employeeId=${id}`).catch(() => {
            })
        },
        goTotalEmployee() {
            this.$router.push(`/user/manage-employee`).catch(() => {
            })
        },
        goIsCheckin(isCheckin) {
            this.$router.push(`/user/time-keeping?isCheckin=${isCheckin}`).catch(() => {
            })
        },
        goIsLate() {
            this.$router.push(`/user/time-keeping?isLate=true`).catch(() => {
            })
        },
        goLeave(organizationBranchId, id) {
            this.$router.push(`/user/edit-leave?branch_id=${organizationBranchId}&id=${id}`).catch(() => {
            });
        },
        getLeave() {
            this.$vs.loading();
            // let employeeSearchDTO = {
            //     enabled: null,
            //     organizationBranchId: null,
            //     organizationId: null
            // };
            // this.$crm.post(`/employee/all`, employeeSearchDTO).then((responseEmployee) => {
            this.$crm.post('/dashboard/today-leave').then((response) => {
                this.leaveData = response.data.map(item => {
                    // let employee;
                    if (item.status === 0) item.displayStatus = "Đang chờ";
                    if (item.status === 1) item.displayStatus = "Đã duyệt";
                    if (item.status === 2) item.displayStatus = "Từ chối";

                    if (item.status === 3) item.displayStatus = "Hủy"
                    item.displayLeaveDate = moment(new Date(item.fromDate)).format("DD/MM/YYYY") + ' - ' + moment(new Date(item.toDate)).format("DD/MM/YYYY");
                    // if (item.employeeId) employee = responseEmployee.data.find(x => x.employeeId === item.employeeId);
                    return item;
                });
                if (this.leaveData.length > 0) this.isShowEmployeeLeave = true;
                this.$vs.loading.close();
                // });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: this.$t('dashboard.errMs'),
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getTotalEmployee() {
            this.$vs.loading();
            this.$crm.get('/employee/total').then((response) => {
                this.totalEmployee = response.data;
                this.$vs.loading.close();
            }).catch(() => {
                return this.$vs.notify({
                    text: this.$t('dashboard.errSumEmployee'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getTotalCheckin() {
            this.$vs.loading();
            this.$crm.get('/time-keeping/count-total-checkin').then((response) => {
                this.totalCheckin = response.data;
                this.$vs.loading.close();
            }).catch(() => {
                return this.$vs.notify({
                    text: this.$t('dashboard.errSumEmployeeCheckin'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getTotalLate() {
            this.$vs.loading();
            this.$crm.get('/time-keeping/count-total-late').then((response) => {
                this.totalLate = response.data;
                this.$vs.loading.close();
            }).catch(() => {
                return this.$vs.notify({
                    text: this.$t('dashboard.errSumEmployeeCheckinLate'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getTotalNotCheckin() {
            this.$vs.loading();
            this.$crm.get('/time-keeping/count-total-not-checkin').then((response) => {
                this.totalNotCheckin = response.data;
                this.$vs.loading.close();
            }).catch(() => {
                return this.$vs.notify({
                    text: this.$t('dashboard.errSumEmployeeNotCheckin'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getEmployeeEarly() {
            this.$vs.loading();
            this.employeeEarly = null;
            this.$crm.get('/time-keeping/employee-early').then((response) => {
                if (response.data && response.data.length > 0) {
                    this.employeeEarly = response.data.map(el => {
                        el.urlImage = el.fileManagers && el.fileManagers.length > 0 ? el.fileManagers[0].url : null;
                        return el;
                    });
                    this.isShowEmployeeEarly = true;
                }
                this.$vs.loading.close();
            }).catch(() => {
                return this.$vs.notify({
                    text: this.$t('dashboard.errSumEmployeeWorkEarly'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getEmployeeLate() {
            this.$vs.loading();
            this.$crm.get('/time-keeping/employee-late').then((response) => {
                if (response.data && response.data.length > 0) {
                    this.employeeLate = response.data.map(el => {
                        el.urlImage = el.fileManagers[0].url;
                        return el;
                    });
                    this.isShowEmployeeLate = true;
                }
                this.$vs.loading.close();
            }).catch(() => {
                return this.$vs.notify({
                    text: this.$t('dashboard.errSumEmployeeWorkLate'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getCheckinDayByDay() {
            let data = {
                startDate: new Date(new Date().getTime() - (60 * 60 * 24 * 1000 * 6)),
                endDate: new Date()
            }
            this.$vs.loading();
            this.$crm.post('/time-keeping/checkin-day-by-day', data).then((response) => {
                //refresh data
                this.notCheckIn.chartOptions.xaxis.categories = [];
                this.earlyCheckIn.chartOptions.xaxis.categories = [];
                this.lateCheckIn.chartOptions.xaxis.categories = [];

                this.notCheckIn.series = [];
                this.earlyCheckIn.series = [];
                this.lateCheckIn.series = [];

                this.notCheckIn.chartOptions.xaxis.categories = response.data
                    .map(x => moment(x.currentDate).format("DD/MM"));
                this.earlyCheckIn.chartOptions.xaxis.categories = response.data
                    .map(x => moment(x.currentDate).format("DD/MM"));
                this.lateCheckIn.chartOptions.xaxis.categories = response.data
                    .map(x => moment(x.currentDate).format("DD/MM"));

                //data chart
                let employeeNotCheckin = response.data.map(x => x.employeeNotCheckin);
                let employeeCheckinEarly = response.data.map(x => x.employeeCheckinEarly);
                let employeeCheckinLate = response.data.map(x => x.employeeCheckinLate);

                this.notCheckIn.series = [{name: "Không chấm công", data: employeeNotCheckin}]
                this.earlyCheckIn.series = [{name: "Đi sớm", data: employeeCheckinEarly}]
                this.lateCheckIn.series = [{name: "Đi muộn", data: employeeCheckinLate}]

                this.isShowLineChartCheckin = true;
                this.$vs.loading.close();
            }).catch(() => {
                return this.$vs.notify({
                    text: this.$t('dashboard.errSumEmployeeNotCheckin'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        async getbookroomMeetings() {
            await this.getMeetingRoom();
            this.$crm.get('/reservation').then((response) => {
                response.data.forEach(x => {
                    let room = this.roomMeeting.find(room => x.roomId === room.id);
                    if (room) x.roomName = room.name;
                    if (x.dateBegin && x.dateEnd) {
                        let minutesBeginString = new Date(x.dateBegin).getMinutes() !== 0 ? (":" + new Date(x.dateBegin).getMinutes()) : ':00';
                        x.dateBeginString = new Date(x.dateBegin).getHours() + minutesBeginString;
                        let minutesDateEndString = new Date(x.dateEnd).getMinutes() !== 0 ? (":" + new Date(x.dateEnd).getMinutes()) : ':00';
                        x.dateEndString = new Date(x.dateEnd).getHours() + minutesDateEndString;
                        x.dateString = x.dateBeginString + " - " + x.dateEndString;
                    }
                });
                this.bookroomMeetings = response.data;
                if (this.bookroomMeetings.length > 0) this.isShowBookMeeting = true;
            }).catch(() => {
                return this.$vs.notify({
                    text: this.$t('dashboard.errGetMeetingZoom'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getMeetingRoom() {
            return new Promise(resolve => {
                this.$vs.loading();
                this.$crm.get('/meeting-room/get').then((response) => {
                    this.roomMeeting = response.data.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            location: item.location
                        }
                    });
                    resolve(true);
                    this.$vs.loading.close();
                }).catch(() => {
                    return this.$vs.notify({
                        text: this.$t('dashboard.errGetMeetingZoom'),
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        async getDayMeetingRom() {
            await this.getMeetingRoom();
            this.$vs.loading();
            this.$crm.get('/reservation/all').then((response) => {
                this.scheduleListDay = response.data.map(item => {
                    if (item.capacity == null) {
                        item.capacity = '0';
                    }
                    if (item.reservationName == null) {
                        item.reservationName = 'Không có tên cuộc họp';
                    }
                    if (item.purpose == null) {
                        item.purpose = '';
                    }
                    let result = this.roomMeeting.filter(x => x.id === item.roomId)
                    if (result.length > 0) {
                        this.roomNameInfor = result[0]
                    }
                    return {
                        title: item.reservationName,
                        body: 'Mục đích: ' + item.purpose + '.',
                        location: 'Phòng: ' + this.roomNameInfor.name + ' tại ' + this.roomNameInfor.location + '.',
                        category: 'time',
                        dueDateClass: "",
                        recurrenceRule: 'Người tham dự: ' + item.participants.map(i => {
                            return i.fullName
                        }) + '.',
                        start: new Date(item.dateBegin),
                        end: new Date(item.dateEnd),
                        borderColor: 'red',
                        bgColor: 'rgba(var(--vs-primary),1)',
                        state: 'Số người tham dự: ' + item.capacity + ' người.'
                    }
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
    created() {
        this.getDayMeetingRom();
        this.getTotalEmployee();
        this.getTotalCheckin();
        this.getTotalLate();
        this.getTotalNotCheckin();
        this.getLeave();
        this.getEmployeeEarly();
        this.getEmployeeLate();
        this.getCheckinDayByDay();
        this.getbookroomMeetings();
    },
}
</script>

<style lang="scss" scoped>
.checkinsoon {
    margin-top: 1rem;
}

.checkinlate {
    margin-top: 1rem;
}

@media only screen and (max-width: 1575px) {
    .checkinsoon {
        margin-top: 0;
    }
    .checkinlate {
        margin-top: 0;
    }
}

.hightlight_subtitle_soon {
    color: rgba(var(--vs-primary), 1);
}

.hightlight_subtitle_late {
    color: rgba(var(--vs-primary), 1);
}

.scroll {
    max-height: 17rem !important;
}

.booking {
    .vs-avatar--con-img {
        border-radius: 10px !important;
    }

    .con-vs-avatar {
        width: 100% !important;
    }
}

/*.leave {*/
/*  .vs-avatar--con-img {*/
/*    border-radius: 10px !important;*/
/*  }*/
/*  .con-vs-avatar {*/
/*    width: 100%!important;*/
/*  }*/
/*}*/
.vs-con-tbody:hover {
    overflow-y: auto !important;
}

.cursor {
    cursor: pointer !important;
}

.card-lave {
    min-height: 330px !important;
    max-height: 330px !important;
}

.card-department {
    min-height: 550px !important;
    // max-height: 330px !important;
}

#dashboard-analytics {
    h4 {
        font-weight: bold !important;
        color: #000000 !important;
    }

    .greet-user {
        position: relative !important;

        .decore-left {
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
        }

        .decore-right {
            position: absolute !important;
            right: 0 !important;
            top: 0 !important;
        }
    }

    @media(max-width: 576px) {
        .decore-left, .decore-right {
            width: 140px !important;
        }
    }
}

/*! rtl:end:ignore */
.employee {
    background-color: #cce5ff !important;
}

.totalEmployee {
    font-weight: 700 !important;
}

.checkinweek {
    min-height: 330px !important;
}

.employeetime {
    width: 250px !important;
}

.opacity02 {
    opacity: 0.2 !important;
}

.checkinok {
    background-color: #d4edda !important;
}

.totalCheckin {
    font-weight: 700 !important;
}

.goIsLate {
    background-color: #F8F2D7 !important;
}

.totalLate {
    font-weight: 700 !important;
}

.goIsCheckin {
    background-color: #f8d7da !important;
}

.totalNotCheckin {
    font-weight: 700 !important;
}

.featherTotalNotCheckin {
    color: #ff0000 !important;
}

.template-vs-td-i {
    width: 18rem !important;
}

.isEmployeeLeave {
    float: left !important;
    padding: 5px !important;
}

.CalendarMeetingRoom {
    height: 688px !important;
}

.calendar-event {
    width: 35% !important;
}

.CalendarEvent {
    height: 688px !important;
}
</style>
<style lang="scss">
.table-checkin {
    .vs-table--tbody-table {
        min-width: 220px !important;
    }

    .vs-table--content {
        min-width: 230px;
    }

    .vs-table--thead th {
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: white;
    }
}

.checkinsoon {
    margin-top: 1rem;
}

.checkinlate {
    margin-top: 1rem;
}

@media only screen and (max-width: 1575px) {
    .checkinsoon {
        margin-top: 0;
    }

    .checkinlate {
        margin-top: 0;
    }
}

.hightlight_subtitle_soon {
    color: #fcb71e;
}

.hightlight_subtitle_late {
    color: #fcb71e;
}

.scroll {
    max-height: 17rem !important;
}

.booking {
    .vs-avatar--con-img {
        border-radius: 10px !important;
    }

    .con-vs-avatar {
        width: 100% !important;
    }
}

.cursor {
    cursor: pointer !important;
}

.card-lave {
    min-height: 345px !important;
    background-color: #fff;
    box-shadow: rgb(99 99 99 / 20%) 0 2px 8px 0;
    border-radius: 7px;
}

.card {
    padding: 1.5rem;

}

#dashboard-analytics {
    h4 {
        font-weight: bold !important;
        color: #000000 !important;
    }

    .greet-user {
        position: relative !important;

        .decore-left {
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
        }

        .decore-right {
            position: absolute !important;
            right: 0 !important;
            top: 0 !important;
        }
    }

    @media(max-width: 576px) {

        .decore-left,
        .decore-right {
            width: 140px !important;
        }
    }
}

.employee {
    background-image: linear-gradient(135deg, #ABDCFF 10%, #4fa5e2 100%) !important;
    box-shadow: rgb(99 99 99 / 20%) 0 2px 8px 0;
    border-radius: 7px 7px 0 0;
}

.totalEmployee {
    font-weight: 700 !important;
    color: #ffff;
}

.checkinweek {
    min-height: 330px !important;
}

.employeetime {
    width: 250px !important;
}

.opacity02 {
    opacity: 0.2 !important;
}

.checkinok {
    background-image: linear-gradient(135deg, #a5ebdc 10%, #23d6b2 100%);
    box-shadow: rgb(99 99 99 / 20%) 0 2px 8px 0;
    border-radius: 7px 7px 0 0;
}

.totalCheckin {
    font-weight: 700 !important;
    color: #ffff;
}

.showIsLate {
    background-image: linear-gradient(135deg, #ffed9e 10%, #dbb610 100%);
    box-shadow: rgb(99 99 99 / 20%) 0 2px 8px 0;
    border-radius: 7px 7px 0 0;
}

.totalLate {
    font-weight: 700 !important;
    color: #ffff;
}

.showIsCheckin {
    background-image: linear-gradient(135deg, #f8c1c5 5%, #ff7480 100%);
    box-shadow: rgb(99 99 99 / 20%) 0 2px 8px 0;
    border-radius: 7px 7px 0 0;

}

.showIsLocation {
    background-image: linear-gradient(135deg, #67e39f80 5%, #16a556 100%);
    box-shadow: rgb(99 99 99 / 20%) 0 2px 8px 0;
    border-radius: 7px 7px 0 0;
}

.organization {
    background-image: linear-gradient(135deg, #fff 10%, #fff 100%);
    box-shadow: rgb(99 99 99 / 20%) 0 2px 8px 0;
    border-radius: 7px;
}

.totalNotCheckin {
    font-weight: 700 !important;
    color: #ffff;
}

.featherTotalNotCheckin {
    color: #ff0000 !important;
}

.template-vs-td-i {
    width: 18rem !important;
}

.isEmployeeLeave {
    float: left !important;
    padding: 5px !important;
}

.textlabel {
    color: #ffff;
}

.detailEmployee {
    background-image: linear-gradient(135deg, #0095ff 10%, #0095ff 100%) !important;
    margin-top: -1rem;
    display: flex;
    justify-content: center;
    border-radius: 0 0 7px 7px;
}

.detailCheckinOk {
    background-image: linear-gradient(135deg, #2fd1b0 10%, #03d1a8 100%) !important;
    margin-top: -1rem;
    display: flex;
    justify-content: center;
    border-radius: 0 0 7px 7px;
}

.detailLate {
    background-image: linear-gradient(135deg, #c6ac3c 10%, #c6a205 100%) !important;
    margin-top: -1rem;
    display: flex;
    justify-content: center;
    border-radius: 0 0 7px 7px;
}

.detailLocation {
    background-image: linear-gradient(135deg, #349962 10%, #009644 100%) !important;
    margin-top: -1rem;
    display: flex;
    justify-content: center;
    border-radius: 0 0 7px 7px;
}

.detailNotChecin {
    background-image: linear-gradient(135deg, #f56874 10%, #ff4151 100%) !important;
    margin-top: -1rem;
    display: flex;
    justify-content: center;
    border-radius: 0 0 7px 7px;
}
</style>
<style lang="scss">
.vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0 1.5rem 1.5rem 1.5rem;
}

.rmNode {
    background-color: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1);
    line-height: 13px;
}

.checkinlate {
    .vs-table--tbody-table {
        min-width: auto !important;
        overflow: hidden !important;
    }
}

.vx-card__title h6 {
    color: #888888 !important;
}

.vx-card__body h6 {
    margin-top: 0.5rem;
}

.zoom {
    transition: transform .2s;
}

.zoom :hover {
    transform: scale(1.05);
}
</style>
